import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import { Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  skeletonContainer: {
    "& span": {
      background: theme.palette.dark[600],
      marginTop: 40
    },
    "& #image": {
      height: 150,
      width: "20%",
      borderRadius: 8,
      [theme.breakpoints.down('md')]: {
        width: "35%",
      }
    },
    "& #title": {
      height: 90,
      borderRadius: 8,
    },
    "& #desc": {
      height: 40,
      marginTop: 20,
      borderRadius: 8,
    },
    [theme.breakpoints.down('md')]: {
      padding: "0 20px",
      marginBottom: -10,
      marginTop: 0
    }
  },
  titleContainer: {
    marginLeft: "5%",
    width: "75%",
    [theme.breakpoints.down('md')]: {
      width: "60%",
    }
  },
}))

const SavedLessonSkeleton: React.FC = () => {
  const classes = useStyles();

  return <Grid container className={classes.skeletonContainer}>
    <Skeleton variant="rect" animation="wave" id="image" />
    <Grid className={classes.titleContainer}>
      <Skeleton variant="rect" animation="wave" id="title" />
      <Skeleton variant="rect" animation="wave" id="desc" />
    </Grid>
  </Grid>;
}

export default SavedLessonSkeleton;